"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reducer = require("./reducer");

var _SystemMessage = require("./SystemMessage");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n\tposition: fixed;\n\tz-index: 950;\n\tright: 50px;\n\ttop: 50px;\n\n\t.system-message {\n\t\tposition: absolute;\n\t\twhite-space: nowrap;\n\t}\n\t.system-message.show {\n\t\topacity: 1;\n\t\tright: 0px;\n\t\tanimation: ", " 0.75s ease-out;\n\t}\n\t.system-message.hide {\n\t\tanimation: ", " 0.75s ease-in;\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\tfrom {\n\t\topacity: 1;\n\t\tright: 0px;\n\t}\n\tto {\n\t\topacity: 0;\n\t\tright: -200px;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tfrom {\n\t\topacity: 0;\n\t\tright: 200px;\n\t}\n\tto {\n\t\topacity: 1;\n\t\tright: 0px;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var show = (0, _styledComponents.keyframes)(_templateObject());
var hide = (0, _styledComponents.keyframes)(_templateObject2());

var SystemMessageContainer = _styledComponents["default"].div(_templateObject3(), show, hide);

var SystemMessages = function SystemMessages(_ref) {
  var messages = _ref.messages,
      dismissSystemMessage = _ref.dismissSystemMessage;
  return !messages.length ? null : /*#__PURE__*/_react["default"].createElement(SystemMessageContainer, null, messages.map(function (message, i) {
    return message.onConfirm ? /*#__PURE__*/_react["default"].createElement(_SystemMessage.ConfirmMessage, _extends({
      key: message.id,
      top: i * 3
    }, message, {
      dismissSystemMessage: dismissSystemMessage
    })) : /*#__PURE__*/_react["default"].createElement(_SystemMessage.SystemMessage, _extends({
      key: message.id,
      top: i * 3
    }, message, {
      dismissSystemMessage: dismissSystemMessage
    }));
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    messages: state.messages
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  dismissSystemMessage: _reducer.dismissSystemMessage
})(SystemMessages);

exports["default"] = _default;